import { c as _c } from "react/compiler-runtime";
import { Divider } from '@xefi/x-react/divider';
type SurveyProgressProps = {
  currentPage: number;
  totalPage: number;
};
export const SurveyProgress = t0 => {
  const $ = _c(11);
  const {
    currentPage,
    totalPage
  } = t0;
  const getProgressBarWidth = () => Math.min(currentPage === 0 ? 5 : Math.max(5, currentPage * 100 / totalPage), 100).toString();
  const t1 = `${getProgressBarWidth()}%`;
  let t2;
  if ($[0] !== t1) {
    t2 = <div id="survey-progress-bar" className="bg-content1-100 h-[6px] w-[100px] rounded-md"><div id="survey-progress" className="bg-primary size-[6px] rounded-2xl" style={{
        width: t1
      }} /></div>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== currentPage || $[3] !== totalPage) {
    t3 = <div className="text-primary text-sm font-bold">{currentPage}/{totalPage}</div>;
    $[2] = currentPage;
    $[3] = totalPage;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <div id="stepper" className="flex items-center"><div className="flex items-center gap-2">{t2}{t3}</div></div>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Divider orientation="vertical" className="h-4.5" />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4) {
    t6 = <div className="flex items-center gap-4">{t4}{t5}</div>;
    $[9] = t4;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};